import { render, staticRenderFns } from "./ProcessHeaderItem.vue?vue&type=template&id=48531d7c"
import script from "./ProcessHeaderItem.ts?vue&type=script&lang=ts&external"
export * from "./ProcessHeaderItem.ts?vue&type=script&lang=ts&external"
import style0 from "./ProcessHeaderItem.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports